export const SET_ASSIGNMENTS = 'assignment/SET_ASSIGNMENTS';
export const SET_ASSIGNMENT_STATS = 'assignment/SET_ASSIGNMENT_STATS';
export const SET_CLASSES = 'aassignment/SET_CLASSES';
export const SET_CLASS_ID = 'aassignment/SET_CLASSES_ID';
export const RESET_ASSIGNMENTS = 'aassignment/RESET_ASSIGNMENTS';



// WEBPACK FOOTER //
// ./src/app/cat-assignment/store/mutation-types.js